export const ADD_BILLING_ADDRESS_REQUEST = 'ADD_BILLING_ADDRESS_REQUEST';
export const ADD_BILLING_ADDRESS_SUCCESS = 'ADD_BILLING_ADDRESS_SUCCESS';
export const ADD_BILLING_ADDRESS_FAILURE = 'ADD_BILLING_ADDRESS_FAILURE';
export const RESET_BILLING_ADDRESS_STATE = 'RESET_BILLING_ADDRESS_STATE';
export const UPDATE_BILLING_ADDRESS_REQUEST = 'UPDATE_BILLING_ADDRESS_REQUEST';
export const UPDATE_BILLING_ADDRESS_SUCCESS = 'UPDATE_BILLING_ADDRESS_SUCCESS';
export const UPDATE_BILLING_ADDRESS_FAILURE = 'UPDATE_BILLING_ADDRESS_FAILURE';
export const FETCH_BILLING_ADDRESS_REQUEST = 'FETCH_BILLING_ADDRESS_REQUEST';
export const FETCH_BILLING_ADDRESS_SUCCESS = 'FETCH_BILLING_ADDRESS_SUCCESS';
export const FETCH_BILLING_ADDRESS_FAILURE = 'FETCH_BILLING_ADDRESS_FAILURE';
export const VIEW_BILLING_ADDRESS_REQUEST = 'VIEW_BILLING_ADDRESS_REQUEST';
export const VIEW_BILLING_ADDRESS_SUCCESS = 'VIEW_BILLING_ADDRESS_SUCCESS';
export const VIEW_BILLING_ADDRESS_FAILURE = 'VIEW_BILLING_ADDRESS_FAILURE';
export const DELETE_BILLING_ADDRESS_REQUEST = 'DELETE_BILLING_ADDRESS_REQUEST';
export const DELETE_BILLING_ADDRESS_SUCCESS = 'DELETE_BILLING_ADDRESS_SUCCESS';
export const DELETE_BILLING_ADDRESS_FAILURE = 'DELETE_BILLING_ADDRESS_FAILURE';
